import axios from "axios";

const configuredBackendUrl = process.env.REACT_APP_BACKEND_URL?.trim();
const backendUrl = configuredBackendUrl || "https://vividh2osolution.com";

export const API_BASE = `${backendUrl.replace(/\/+$/, "")}/api`;

export const apiClient = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

// Fallback to static JSON files if API fails
const staticApiCache = {};

async function fetchWithFallback(endpoint) {
  try {
    // Try API first
    const response = await apiClient.get(endpoint);
    return response.data;
  } catch (error) {
    // Fallback to static JSON files
    const jsonMap = {
      "/products": "/api/products.json",
      "/products/categories": "/api/products.json",
      "/services": "/api/services.json"
    };
    
    // Check if it's a slug-based endpoint like /products/{slug}
    const productSlugMatch = endpoint.match(/^\/products\/([^/]+)$/);
    const serviceSlugMatch = endpoint.match(/^\/services\/([^/]+)$/);
    
    // Load products.json if needed
    if (productSlugMatch || !staticApiCache["/api/products.json"]) {
      if (!staticApiCache["/api/products.json"]) {
        const response = await fetch("/api/products.json");
        staticApiCache["/api/products.json"] = await response.json();
      }
      
      if (productSlugMatch) {
        const slug = productSlugMatch[1];
        const products = staticApiCache["/api/products.json"];
        const product = products.find(p => p.slug === slug);
        if (product) {
          return product;
        }
      }
    }
    
    // Load services.json if needed
    if (serviceSlugMatch || !staticApiCache["/api/services.json"]) {
      if (!staticApiCache["/api/services.json"]) {
        const response = await fetch("/api/services.json");
        staticApiCache["/api/services.json"] = await response.json();
      }
      
      if (serviceSlugMatch) {
        const slug = serviceSlugMatch[1];
        const services = staticApiCache["/api/services.json"];
        const service = services.find(s => s.slug === slug);
        if (service) {
          return service;
        }
      }
    }
    
    // Handle list endpoints
    const jsonFile = jsonMap[endpoint];
    if (jsonFile) {
      if (!staticApiCache[jsonFile]) {
        const response = await fetch(jsonFile);
        staticApiCache[jsonFile] = await response.json();
      }
      
      if (endpoint === "/products/categories") {
        const products = staticApiCache[jsonFile];
        const categories = [...new Set(products.map(p => p.category))];
        return { categories };
      }
      
      return staticApiCache[jsonFile];
    }
    throw error;
  }
}

// Override get method to use fallback
const originalGet = apiClient.get.bind(apiClient);
apiClient.get = function(url, ...args) {
  if (url.includes("/products") || url.includes("/services")) {
    return fetchWithFallback(url).then(data => ({ data }));
  }
  return originalGet(url, ...args);
};
